export default "<p>home works!</p>\r\n<a routerLink=\"auth\">Get Started</a>\r\n"